import * as React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import { navigate } from 'libs/router';

import BaseInfluencerAgencyPage from 'modules/influencers-agency/pages/BaseInfluencerAgencyPage';
import InfluencersAgencyEditForm from 'modules/admin/components/influencers-agencies/InfluencersAgencyEditForm';

import {
  fetchInfluencersAgency,
  updateInfluencersAgency
} from 'modules/influencers-agency/reducers/influencers-agencies-reducer';

import { isAdmin } from 'utils/account';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('../influencers-agencies-pages.i18n.json'));

import { InfluencersAgency, Params } from 'types';

type OwnProps = {
  params: Params
};

type StateProps = {
  agency: InfluencersAgency,
  isAdminMode: boolean
}

type DispatchProps = {
  dispatchUpdateInfluencersAgency: (data: InfluencersAgency) => Promise<any>,
  dispatchFetchInfluencersAgency: (agencyId: number) => Promise<any>
}

type Props = OwnProps & StateProps & DispatchProps;

const InfluencersAgencyEditProfilePage = ({
  agency,
  isAdminMode,
  dispatchUpdateInfluencersAgency,
  dispatchFetchInfluencersAgency,
  params }: Props) => {
  const agencyId = Number(params.id);

  useEffect(() => {
    dispatchFetchInfluencersAgency(agencyId);
  }, [params.id]);

  const handleSubmit = async (agencyProfile: InfluencersAgency) => {
    await dispatchUpdateInfluencersAgency(agencyProfile);

    const redirectLink = `${isAdminMode ? '/admin' : ''}/influencers-agencies/${agencyId}/settings/profile`;
    navigate.to(redirectLink);
  };

  return (
    <BaseInfluencerAgencyPage
      agencyId={agencyId}
      documentTitle={__t('influencers_agencies_pages.edit_profile_heading')}
    >
      <InfluencersAgencyEditForm agency={agency} onSubmit={handleSubmit} />
    </BaseInfluencerAgencyPage>
  );
};

const mapStateToProps = ({ influencersAgency, account }): StateProps => ({
  agency: influencersAgency.profile,
  isAdminMode: isAdmin(account.currentAccount, account.roles)
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchUpdateInfluencersAgency: (agencyProfile: InfluencersAgency) => dispatch(updateInfluencersAgency(agencyProfile)),
  dispatchFetchInfluencersAgency: (agencyId: number) => dispatch(fetchInfluencersAgency(agencyId))
});

export default connect(mapStateToProps, mapDispatchToProps)(InfluencersAgencyEditProfilePage);
